const hbTabItem = document.querySelectorAll("[js-hb-tab-item]");
const hbTabContent = document.querySelectorAll("[js-hb-tab-content]");
hbTabContent[0].classList.add("selected");
hbTabItem.forEach((evt, indx) => {
  evt.addEventListener("click", function () {
    hbTabItem.forEach((header) => header.classList.remove("selected"));
    hbTabContent.forEach((content) => content.classList.remove("selected"));
    evt.classList.add("selected");
    hbTabContent[indx].classList.add("selected");
  });
});

const metaVideoContainer = document.querySelector("[js-meta-video-container]");
if (metaVideoContainer) {
  const metaVideo = metaVideoContainer.querySelector("[js-meta-video]");
  const playIcon = metaVideoContainer.querySelector("[js-play-icon]");
  const pauseIcon = metaVideoContainer.querySelector("[js-pause-icon]");

  metaVideo.addEventListener("click", handleVideo);
  metaVideo.addEventListener("ended", function () {
    playIcon.classList.add("is-active");
    pauseIcon.classList.remove("is-active");
    this.classList.remove("is-play");
  });

  function handleVideo() {
    this.classList.toggle("is-play");

    if (this.classList.contains("is-play")) {
      playIcon.classList.remove("is-active");
      pauseIcon.classList.remove("is-active");

      metaVideo.play();
    } else {
      playIcon.classList.remove("is-active");
      pauseIcon.classList.add("is-active");

      metaVideo.pause();
    }
  }
}

const productDataSection = document.querySelector("[js-product-data-section]");

if (productDataSection && window.innerWidth > 960) {
  const items = productDataSection.querySelectorAll("[js-column-contants]");
  let height = 0;
  items?.forEach((item) => {
    if (item.clientHeight > height) {
      height = item.clientHeight;
    }
  });
  items?.forEach((item) => {
    item.style.minHeight = `${height}px`;
  });
}

class BenefitList extends HTMLElement {
  constructor() {
    super();
    this.benefitBtn = this.querySelector("[js-benefits-btn]");
    this.hiddenBenefits = this.querySelectorAll("[js-hidden-benefit]");
    this.dropdownContents = this.querySelector("[js-dropdown-contents]");
    this.init();
  }

  init() {
    this.benefitBtn.addEventListener("click", () => {
      if (this.benefitBtn.classList.contains("all-contents-showing")) {
        this.benefitBtn.classList.remove("all-contents-showing");
        this.hiddenBenefits.forEach((item) => {
          item.style.opacity = 0;
          setTimeout(() => {
            item.style.maxHeight = `0px`;
          }, 200);
        });
        this.dropdownContents.style.height = `0px`;
      } else {
        this.benefitBtn.classList.add("all-contents-showing");
        this.hiddenBenefits.forEach((item) => {
          const height = item.querySelector(".icon-with-text-wrap").clientHeight;
          item.style.maxHeight = `${height}px`;
          setTimeout(() => {
            item.style.opacity = 1;
          }, 200);
        });
        const metafieldDescriptionHeight =
          this.dropdownContents.querySelector("[js-inner-child]").clientHeight;
        this.dropdownContents.style.height = `${metafieldDescriptionHeight}px`;
      }
    });
  }
}

customElements.define("benefit-list", BenefitList);

class DropdownDescription extends HTMLElement {
  constructor() {
    super();
    this.readMoreBtn = this.querySelector("[js-read-more-btn]");
    this.dropdownContents = this.querySelector("[js-dropdown-contents]");
    this.dropDownImage = this.querySelector("[js-dropdown-image-wrapper]");
    this.init();
  }

  init() {
    this.readMoreBtn.addEventListener("click", () => {
      if (this.readMoreBtn.classList.contains("all-contents-showing")) {
        this.readMoreBtn.classList.remove("all-contents-showing");
        if (this.dropDownImage && !this.dropDownImage.classList.contains("hidden")) {
          // this.dropDownImage.style.height = '0rem';
          this.dropDownImage.style.opacity = 0;
        }
        if (window.innerWidth < 960) {
          this.dropdownContents.style.maxHeight = `5rem`;
        } else {
          this.dropdownContents.style.maxHeight = `6rem`;
        }
      } else {
        this.readMoreBtn.classList.add("all-contents-showing");
        if (this.dropDownImage) {
          // this.dropDownImage.style.height = 'auto';
          this.dropDownImage.style.opacity = 1;
        }
        const height = this.dropdownContents.querySelector("[js-inner-child]").clientHeight;
        this.dropdownContents.style.maxHeight = `${height}px`;
      }
    });
  }
}

customElements.define("dropdown-description", DropdownDescription);

(() => {
  const faynCustomOptions = document.querySelectorAll("[js-fayn-custom-option]");
  const variantDescriptionWrapper = document.querySelector("[js-variant-metafields-description]");
  const variantIngredientImageWrapper = document.querySelector(
    "[js-variant-metafields-ingredient-image]"
  );
  const variantIngredientBgImageWrapper = document.querySelector(
    "[js-variant-metafields-ingredient-bg-image]"
  );
  const mainProductSection = document.querySelector("[js-main-product-section]");
  const customOptionsWrapper = document.querySelector("[js-custom-options-wrapper]");
  const portionWeight = document.querySelector("[js-product-portion-weight]");

  faynCustomOptions.forEach((option) => {
    option.addEventListener("click", (evt) => {
      const varientDescription = option.dataset.variantDescription;
      const varientIngredientImageUrl = option.dataset.variantIngredientImageUrl;
      const varientIngredientBgImageUrl = option.dataset.variantIngredientBgImageUrl;
      const color = option.dataset.color;
      const weight = option.dataset.weight;

      mainProductSection.style.backgroundColor = color;
      customOptionsWrapper.style.backgroundColor = color;
      mainProductSection.dataset.variantBadge = option.dataset.variantBadge;

      if (variantDescriptionWrapper) {
        variantDescriptionWrapper.innerHTML = varientDescription;
      }
      if (varientIngredientImageUrl && variantIngredientImageWrapper) {
        variantIngredientImageWrapper.classList.remove("hidden");

        const img = variantIngredientImageWrapper.querySelector("img");

        // Remove all lazyload-related classes and attributes
        img.classList.remove("lazyload", "lazyloaded", "lazyautosizes", "ls-is-cached");
        img.removeAttribute("data-srcset");
        img.removeAttribute("data-sizes");
        img.removeAttribute("srcset");

        // Force eager loading
        img.loading = "eager";

        // Set the new image URL
        img.src = varientIngredientImageUrl.replace(/_50x/, "");
      } else if (variantIngredientImageWrapper) {
        variantIngredientImageWrapper.classList.add("hidden");
        const img = variantIngredientImageWrapper.querySelector("img");
        img.src = "";
        img.removeAttribute("srcset");
        img.removeAttribute("data-srcset");
      }

      if (variantIngredientBgImageWrapper && !varientIngredientBgImageUrl?.includes(".gif")) {
        variantIngredientBgImageWrapper.classList.remove("hidden");
        variantIngredientBgImageWrapper.style.backgroundImage = `url('${varientIngredientBgImageUrl}')`;
      } else if (variantIngredientBgImageWrapper) {
        variantIngredientBgImageWrapper.classList.add("hidden");
      }

      // variantSlider.select(evt.currentTarget.getAttribute("data-index"));

      if (portionWeight) {
        if (weight) {
          portionWeight.classList.remove("hidden");
          portionWeight.textContent = weight;
        } else {
          portionWeight.classList.add("hidden");
          portionWeight.textContent = "";
        }
      }
    });
  });
})();
